module.exports = "<h4>Add a Condition</h4>\n<p>Conditions can control whether or not one or more other automation actions are executed when a automation event occurs.  Use the lists below to identify the condition that you want to use to determine if other automation actions should be executed.  You will those automation actions on different page.</p>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/advanced/codeitem-condition/codeitem-condition.component.html
// module id = 1512
// module chunks = 2